import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/hooks/useFetch";
import { EVENT_STATUS, fmtLocal, fmtTime } from "@/lib/format";
import { MapBadge } from "@/components/StatusBadge";
import { Card, Empty, PageHeader } from "@/components/Field";
import { EventDialog } from "@/components/dialogs/EventDialog";

export default function EventsPage() {
  const { can } = useAuth();
  const nav = useNavigate();
  const [tab, setTab] = useState("upcoming");
  const [dialog, setDialog] = useState(false);
  const { data } = useFetch(`/events?upcoming=${tab === "upcoming"}`);

  return (
    <>
      <PageHeader title="Eventi">
        {can("events", "create") && <Button data-testid="events-new-button" className="h-11" onClick={() => setDialog(true)}><Plus className="h-4 w-4 mr-1" /> Crea evento</Button>}
      </PageHeader>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="h-11">
          <TabsTrigger value="upcoming" className="h-9 px-4" data-testid="events-tab-upcoming">Prossimi</TabsTrigger>
          <TabsTrigger value="all" className="h-9 px-4" data-testid="events-tab-all">Tutti</TabsTrigger>
        </TabsList>
      </Tabs>
      {data && data.length === 0 ? <Empty testId="events-empty" text="Nessun evento." /> : (
        <Card><ul className="divide-y">
          {data?.map((e) => (
            <li key={e.id}>
              <button data-testid={`event-row-${e.id}`} onClick={() => nav(`/eventi/${e.id}`)} className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left hover:bg-slate-50">
                <div className="min-w-0">
                  <div className="text-base font-semibold text-slate-900">{e.name}</div>
                  <div className="text-sm text-slate-500">{fmtLocal(e.start)}–{fmtTime(e.end)}{e.location && ` · ${e.location}`}{e.manager_name && ` · resp. ${e.manager_name}`}</div>
                </div>
                <MapBadge map={EVENT_STATUS} value={e.status} />
              </button>
            </li>
          ))}
        </ul></Card>
      )}
      <EventDialog open={dialog} onOpenChange={setDialog} onSaved={(e) => nav(`/eventi/${e.id}`)} />
    </>
  );
}
